module.exports = __webpack_public_path__ + "img/icon3.04e94d01.svg";